module.exports = __webpack_public_path__ + "img/questions-impostor.b9273210.webp";